import type { FC } from "react";
import { Col, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";

import { AchievementIcon } from "components";
import { Lightbox } from "components/Lightbox";
import type { IBadgeResult } from "pages/Statistics/Tabs/Badges";

import IconArrowLeft from "images/icons/arrow-left.svg";
import IconArrowRight from "images/icons/arrow-right.svg";

interface Props {
  badge: IBadgeResult | null;
  isShown: boolean;
  isNavShown?: boolean;
  goNext: () => void;
  goPrev: () => void;
  onClose: () => void;
}

const BadgeModal: FC<Props> = ({ badge, isShown, isNavShown = true, goNext, goPrev, onClose }) => {
  if (badge === null) return null;

  const formatDateForHumans = (date: Date) => `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;

  return (
    <Lightbox
      show={isShown}
      onHide={onClose}
      dialogClassName={"modal-dialog--center"}
      bodyClassName={"pb-40px"}
      title={badge.title}
    >
      <Row>
        <Col xs={"auto"} className="px-0 flex-column d-flex justify-content-center">
          {isNavShown ? (
            <Button className={"btn-circular btn-circular--sm"} variant={"light"} onClick={goPrev}>
              <IconArrowLeft className={"flex-shrink-0"} />
            </Button>
          ) : null}
        </Col>
        <Col className={"text-center"}>
          <p
            className={"mb-12px"}
            dangerouslySetInnerHTML={{ __html: badge.isEarned ? badge.modalTextEarned : badge.modalTextNotEarned }}
          />
          <div className={badge.isEarned ? "" : "achievement--inactive bg-white"}>
            <AchievementIcon icon={badge.icon} count={badge.count} />
          </div>
          <p className={"fs-13 mb-0 mt-8px"}>
            {badge.dateEarned === null ? "" : formatDateForHumans(badge.dateEarned)}
          </p>
        </Col>
        <Col xs={"auto"} className="px-0 flex-column d-flex justify-content-center">
          {isNavShown ? (
            <Button className={"btn-circular btn-circular--sm"} variant={"light"} onClick={goNext}>
              <IconArrowRight className={"flex-shrink-0"} />
            </Button>
          ) : null}
        </Col>
      </Row>
    </Lightbox>
  );
};

export default BadgeModal;
